export const RUN_TASK_WIDGET_ID = 'AGENT_MAKER_RUN_TASK_WIDGET';
export const ENTRIES_POLL_INTERVAL = 2000;
export const AUTOMATION_TIMEOUT_DURATION = 10 * 60 * 1000; // 10 minutes
export const TRIGGER_ICON_SIZE = 30;
export const DEFAULT_LOCALE = 'en';
export let RunTaskEntryType = /*#__PURE__*/function (RunTaskEntryType) {
  RunTaskEntryType["Loading"] = "loading";
  RunTaskEntryType["Trigger"] = "trigger";
  RunTaskEntryType["ToolCall"] = "toolCall";
  RunTaskEntryType["End"] = "end";
  return RunTaskEntryType;
}({});
export let RunTaskEntryStatus = /*#__PURE__*/function (RunTaskEntryStatus) {
  RunTaskEntryStatus["Loading"] = "loading";
  RunTaskEntryStatus["Pending"] = "pending";
  RunTaskEntryStatus["Succeeded"] = "succeeded";
  RunTaskEntryStatus["Failed"] = "failed";
  RunTaskEntryStatus["Completed"] = "completed";
  return RunTaskEntryStatus;
}({});
export let RunTaskWidgetAction = /*#__PURE__*/function (RunTaskWidgetAction) {
  RunTaskWidgetAction["Completed"] = "completed";
  RunTaskWidgetAction["Updated"] = "updated";
  RunTaskWidgetAction["Stopped"] = "stopped";
  return RunTaskWidgetAction;
}({});
export let RunTaskWidgetSideEffect = /*#__PURE__*/function (RunTaskWidgetSideEffect) {
  RunTaskWidgetSideEffect["Approved"] = "runTaskWidgetApproved";
  RunTaskWidgetSideEffect["Rejected"] = "runTaskWidgetRejected";
  RunTaskWidgetSideEffect["Completed"] = "runTaskWidgetCompleted";
  return RunTaskWidgetSideEffect;
}({});
export let RunTaskEntryApprovalStatus = /*#__PURE__*/function (RunTaskEntryApprovalStatus) {
  RunTaskEntryApprovalStatus["Pending"] = "pending";
  RunTaskEntryApprovalStatus["Approved"] = "approved";
  RunTaskEntryApprovalStatus["Rejected"] = "rejected";
  return RunTaskEntryApprovalStatus;
}({});
export let ModalId = /*#__PURE__*/function (ModalId) {
  ModalId["ViewDetails"] = "e30aea63-f154-4e0f-a7ee-5308d1c44ca0";
  ModalId["EditApproval"] = "1ca038a7-3845-4459-b628-101ca8d65ec6";
  return ModalId;
}({});
export let ModuleEvent = /*#__PURE__*/function (ModuleEvent) {
  ModuleEvent["EditApprovalCanceled"] = "customAgent.editApprovalCanceled";
  ModuleEvent["EditApprovalAccepted"] = "customAgent.editApprovalAccepted";
  ModuleEvent["EditApprovalRejected"] = "customAgent.editApprovalRejected";
  return ModuleEvent;
}({});
//# sourceMappingURL=constants.js.map